import React from 'react'
import PropTypes from 'prop-types'
import { map, partial } from 'lodash-es'
import classnames from 'classnames'
import {
  If,
  Then,
  Else,
  DragDropComponent,
  DragHandle,
} from '../../../../components'
import { SpeakerBaseDetailsComponent } from '../index'

import './CompactListComponent.scss'

const renderSpeaker = (opt, speaker) => {
  const {
    isEditable,
    viewOnly,
    onEditButtonClick,
    style,
    size,
    showDemoteButton,
    showChyronControls,
  } = opt

  const itemClassName = classnames(
    'speaker-compact-list-item',
    { 'is-editable': isEditable && !viewOnly },
    { 'with-drag-handle': isEditable }
  )

  const isAttendeeDemotable = speaker.creation_source === 'guest'

  return (
    <div
      key={speaker.live_speaker_id}
      {...(isEditable &&
        !viewOnly && { onClick: () => onEditButtonClick(speaker) })}
      className={itemClassName}
    >
      <SpeakerBaseDetailsComponent
        speaker={speaker}
        isEditable={isEditable}
        isAttendeeDemotable={isAttendeeDemotable}
        viewOnly={viewOnly}
        style={style}
        size={size}
        showDemoteButton={showDemoteButton}
        showChyronControls={showChyronControls}
      >
        {isEditable && <DragHandle />}
      </SpeakerBaseDetailsComponent>
    </div>
  )
}

const CompactListComponent = ({ speakers, reorder, ...props }) => {
  const { isEditable } = props
  return (
    <div className="compact-list-component">
      <If condition={isEditable}>
        <Then>
          <DragDropComponent
            items={speakers}
            renderItem={partial(renderSpeaker, props)}
            keyExtractor={(speaker) => speaker.live_speaker_id}
            useDragHandle
            onDragEnd={reorder}
            lockAxis="y"
          />
        </Then>
        <Else>{map(speakers, partial(renderSpeaker, props))}</Else>
      </If>
    </div>
  )
}

CompactListComponent.propTypes = {
  speakers: PropTypes.arrayOf(PropTypes.object),
  onEditButtonClick: PropTypes.func,
  isEditable: PropTypes.bool,
  viewOnly: PropTypes.bool,
  reorder: PropTypes.func,
  style: PropTypes.object,
  size: PropTypes.oneOf(['small', 'large']),
  showDemoteButton: PropTypes.bool,
  showChyronControls: PropTypes.bool,
}

CompactListComponent.defaultProps = {
  isEditable: false,
  showDemoteButton: false,
  showChyronControls: false,
}

export default CompactListComponent
